export const LAST_CAUSE_CLICKED = 'lastCauseClicked';
